/**
 * Empresa según el subdominio desde el que se abre la app: `<código>.agrovid.solutions`.
 * El código del subdominio es el código de la empresa (p. ej. `app` → Agrovid, `test` → test1).
 * No son empresa: la landing (`agrovid.solutions`, `www`), la galería (`ifpa`), la demo
 * (`demo`, con su pantalla de roles en /demo/login) ni `api`.
 */
const TENANT_DOMAIN = 'agrovid.solutions';
const NOT_A_TENANT = new Set(['www', 'ifpa', 'demo', 'api']);

function currentHost(): string {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

export function tenantCodeFromHost(hostname: string = currentHost()): string | null {
  const host = hostname.toLowerCase();
  const suffix = `.${TENANT_DOMAIN}`;
  if (!host.endsWith(suffix)) return null;
  const label = host.slice(0, -suffix.length);
  if (!/^[a-z0-9-]+$/.test(label) || NOT_A_TENANT.has(label)) return null;
  return label;
}

/**
 * URL absoluta de otra empresa en su propio subdominio (`https://<código>.agrovid.solutions/…`),
 * o null si la app no corre bajo el dominio propio (CloudFront, localhost): ahí se sigue usando
 * la ruta `/<código>/…`.
 */
export function tenantHostUrl(code: string, path = '/', hostname: string = currentHost()): string | null {
  const host = hostname.toLowerCase();
  if (host !== TENANT_DOMAIN && !host.endsWith(`.${TENANT_DOMAIN}`)) return null;
  if (!/^[a-z0-9-]+$/.test(code)) return null;
  return `https://${code}.${TENANT_DOMAIN}${path.startsWith('/') ? path : `/${path}`}`;
}

/**
 * Raíz del dominio propio (`https://agrovid.solutions/`), o null si la app no corre bajo él
 * (CloudFront, localhost). Destino de los subdominios que no son una empresa.
 */
export function apexUrl(hostname: string = currentHost()): string | null {
  const host = hostname.toLowerCase();
  if (host !== TENANT_DOMAIN && !host.endsWith(`.${TENANT_DOMAIN}`)) return null;
  return `https://${TENANT_DOMAIN}/`;
}
